// extracted by mini-css-extract-plugin
export default {"summaryContent":"CollapsedContainerRow_summaryContent__0a5UX","loading":"CollapsedContainerRow_loading__s-Yvn","accordionIcon":"CollapsedContainerRow_accordionIcon__fsIgU"};